/**
 * defa.collections.InvitationSubscriptions
 * A Collection of Subscriptions for an invitation.
 * @version 1.0.0
 * @author Benjamin Rusten
 */
import InvitationSubscription from 'scripts/defa/invitations/subscriptions/model-invitation-subscription';

const InvitationSubscriptions = Bb.Collection.extend({
		
		// ------------------------------------------------
		// Setup
		// ------------------------------------------------
		
	model : InvitationSubscription,
		
		
		
		
		// ------------------------------------------------
		// Event Handlers
		// ------------------------------------------------
		
		// ------------------------------------------------
		// Other functions
		// ------------------------------------------------
		
});

export default InvitationSubscriptions;
